import { FC, useState, useEffect } from "react";
import { FormControl, Modal, Table } from "react-bootstrap";
import moment from "moment";
import userApi from "../../../api/userApi";
import { User } from "../../../types/User";
import { TimesheetAuditLog } from "../../../types/UserChangeLog";
import { formatMinutes } from "../../../utils/time";

interface Props {
  user: User;
  visible: boolean;
  onVisibleChange: (val: boolean) => void;
}

const ChangeLogModal: FC<Props> = ({ user, visible, onVisibleChange }) => {
  const [logs, updateLogs] = useState<TimesheetAuditLog[]>([]);
  const [version, setVersion] = useState<"v1" | "v2">("v1");

  useEffect(() => {
    if (visible) {
      const fetchLogs = async () => {
        try {
          const res = await userApi.getTimesheetLogs(user.id, version);
          updateLogs(res.data.logs);
        } catch {
          // eslint-disable-next-line
          console.error("Fetch failed");
        }
      };
      fetchLogs();
    }
  }, [visible, version]);

  return (
    <Modal show={visible} onHide={() => onVisibleChange(false)} size="lg">
      <Modal.Header closeButton={true} className="d-flex justify-content-between">
        <Modal.Title className="flex-grow-1">Timesheet balance logs</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormControl as="select" value={version} onChange={(e) => setVersion(e.target.value as "v1" | "v2")}>
          <option value={"v1"}>Version 1</option>
          <option value={"v2"}>Version 2</option>
        </FormControl>
        <Table>
          <thead>
            <tr>
              <th>Old balance</th>
              <th>New balance</th>
              <th>Type</th>
              <th>Editor</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id}>
                <td>{formatMinutes(l.oldBalance)}</td>
                <td>{formatMinutes(l.newBalance)}</td>
                <td>{l.logType}</td>
                <td>{l.editor}</td>
                <td>{moment(l.createdAt).format("lll")}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};

export default ChangeLogModal;
